import type { JSX } from 'react';

/**
 * Le panneau Home est dessine a l'echelle de la maquette 1920 ; rendu tel quel
 * il est trop gros. Ratio valide par le fondateur sur son 15 pouces : 84 %.
 * Constante, jamais fluide : la vue du 15 pouces fait foi partout, et la
 * constance physique d'un ecran a l'autre est deja assuree par useDisplayScale
 * (qui corrige la racine rem, donc la boite du panneau avec).
 *
 * Les surfaces de travail (app plein ecran, hub Parametres) ne sont PAS
 * concernees : leur gabarit est deja en densite compacte, elles rendent a
 * 100 % de la taille de reference.
 *
 * Elle vit ICI, et pas dans `HomePanel.tsx`, pour que l'apercu de Parametres >
 * Environnement la lise sans charger le panneau (et l'auth avec lui).
 */
export const HOME_PANEL_SCALE = 0.84;

/**
 * LE LOGO DU CLIENT EN HAUT DE L'ACCUEIL, et la SEULE source de sa taille :
 * l'accueil le monte dans son rail, l'apercu de Parametres > Environnement le
 * monte tel quel sous le meme zoom ({@link HOME_PANEL_SCALE}).
 *
 * 36 px de haut (30 a l'ecran, sous le zoom) : tranche par le fondateur le
 * 15/09/2026 en regardant le vrai logo d'un client. Les 42 px de la maquette
 * (Spot Motion E2) remplissaient toute la largeur du rail avec un lockup large.
 * L'apercu, lui, recopiait les classes sans le zoom et montrait le logo 19 %
 * plus grand qu'a l'accueil : d'ou ce composant partage.
 *
 * `max-w-full object-contain` : un lockup plus large que le rail retrecit en
 * gardant ses proportions, au lieu de se faire ecraser a la largeur du rail.
 * Sans logo, le nom de l'environnement, en texte.
 */
export function LogoAccueil({ nom, logo }: { nom: string; logo: string | null }): JSX.Element {
  if (logo == null || logo === '') {
    return <span className="text-base font-semibold text-ink-900">{nom}</span>;
  }
  return <img src={logo} alt={nom} className="block h-9 w-auto max-w-full object-contain" />;
}
